import React, { useMemo, useState } from 'react';
import Form, { FormInputComponent } from "../../components/form/Form";
import { useAuth } from "../../providers/AuthProvider";
import { Radio, Select, Space, Input } from 'antd';
import { usePositionOverride } from "../../providers/PositionOverrideProvider";
import { usePosition } from "../../providers/ProjectPositionProvider";
import SpinLoader from "../../components/SpinLoader";
import { useProject } from '../../providers/ClientProjectProvider';


const STATES = [
    'AL', 'AK',
    'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL',
    'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA',
    'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE',
    'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK',
    'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
    'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY', 'AE', 'AA', 'AP',
]

const COUNTRIES = [
    { label: 'US', value: 'US' }
]

const PositionCandidateGreenlightModal = ({ onClose }) => {
    const { auth } = useAuth();
    const { position, isLoading } = usePosition();
    const { project } = useProject();
    const { updateTaxPreference, isDisabled } = usePositionOverride();
    const candidate = position.assigned_candidate;
    const candidateTaxPreference = useMemo(() => {
        if (!candidate?.client_tax_preference) {
            return undefined;
        }
        switch (candidate.client_tax_preference) {
            default:
            case "ic-only":
            case "ee-only":
                return candidate.client_tax_preference
            case "ic-preferred":
            case "any":
                return 'any'
        }
    }, [position, isDisabled])
    const [formModel, setFormModel] = useState({
        employed_by: candidate?.employed_by,
        client_tax_preference: candidateTaxPreference,
        is_onsite: candidate?.is_onsite,
        work_timezone: candidate?.work_timezone,
        client_tax_questions: [
            ...(laravel.greenlight_tax_class_questions?.US || [])
        ],
        location: project.location,
    });

    const placeHolderOption = { label: 'Please select an option...', value: false, disabled: true };
    const taxClassificationOptions = useMemo(() => {
        return [placeHolderOption, ...TB.map(TB.filter(laravel.greenlight_tax_class_preferences || [], item => item.value !== 'wripple'),
            ({ key, label }) => {
                return {
                    label,
                    value: key
                }
            })]
    }, []);
    const timezoneOptions = useMemo(() => {
        return [placeHolderOption, ...TB.map(Intl.supportedValuesOf('timeZone'), timezone => {
            return {
                label: timezone,
                value: timezone
            }
        })
        ]
    }, []);

    const statesOptions = useMemo(() => {
        return [placeHolderOption, ...TB.map(STATES, state => ({
            label: state,
            value: state
        }))]
    }, [])

    const shouldShowWorkTerms = useMemo(() => {
        return !!formModel.client_tax_preference
    }, [formModel?.client_tax_preference]);

    const shouldShowTaxQuestions = useMemo(() => {
        return !!formModel.client_tax_preference
            && formModel.client_tax_preference !== 'ee-only'
    }, [formModel?.client_tax_preference]);

    const submitTaxPreference = async () => {
        let params = { ...formModel };
        if (!shouldShowTaxQuestions) {
            delete params.client_tax_questions
        }
        if (!shouldShowWorkTerms) {
            delete params.is_onsite
            delete params.work_timezone
        }
        if (!params.is_onsite) {
            delete params.location;
        }
        console.log('submitTaxPreference', params)
        let updatedModel = await updateTaxPreference(params);

        if (updatedModel) {
            await onClose();

            await TB.toast('Greenlight Request Started', { type: 'success' })
        }
    }

    return (
        <SpinLoader isLoading={isDisabled}>
            <div>

                <h4 className="scheduler-header">
                    Greenlight Onboarding
                </h4>

                <React.Fragment>
                    <div>
                        <p className="my-3">
                            Answer the questions below and submit the form to begin the onboarding process.
                            The candidate will get notified to complete their onboarding through Greenlight.
                        </p>
                    </div>
                    <Form
                        background={'transparent'}
                        onChange={(model) => {
                            let updatedModel = { ...formModel };
                            for (let [key, value] of Object.entries(model)) {
                                updatedModel = TB.set(updatedModel, key, value);
                            }
                            console.log('updated modal ', updatedModel)
                            setFormModel(updatedModel);
                        }}
                        minimal
                        disabled={isDisabled}
                        onSubmit={submitTaxPreference}
                        submitButton={false}
                        model={formModel}
                    >

                        <div className="flex flex-col items-stretch gap-3">

                            <div className="field-section flex-row">
                                <div className="field basis-full [&_.invalid-feedback]:relative">
                                    <FormInputComponent
                                        type="antd-input"
                                        label="What is the preferred Tax Class?"
                                        required={true}
                                        fieldName={`client_tax_preference`}
                                        value={formModel.client_tax_preference}>

                                        <Radio.Group value={formModel.client_tax_preference}>
                                            <Space direction="vertical">
                                                <Radio value={'ee-only'}>
                                                    W2
                                                </Radio>
                                                <Radio value={'ic-only'}>
                                                    1099
                                                </Radio>
                                                <Radio value={'ic-preferred'}>
                                                    1099 Preferred Otherwise W2
                                                </Radio>
                                                <Radio value={'any'}>
                                                    No Preference
                                                </Radio>
                                            </Space>
                                        </Radio.Group>

                                    </FormInputComponent>
                                </div>
                            </div>

                            <div className="field-section flex-row">
                                <div className="field basis-full lg:basis-2/3">
                                    <FormInputComponent
                                        type="antd-input"
                                        label="Will the candidate be requried on-site?"
                                        required={true}
                                        fieldName={`is_onsite`}
                                        value={formModel.is_onsite}>

                                        <Radio.Group value={formModel.is_onsite}>
                                            <Radio value={true}>
                                                Yes
                                            </Radio>
                                            <Radio value={false}>
                                                No
                                            </Radio>
                                        </Radio.Group>

                                    </FormInputComponent>
                                </div>
                            </div>

                            {/* 
                                location.'address_line_1' => 'nullable|string|max:255',
                                location.'address_line_2' => 'nullable|string|max:255',
                                location.'city'           => 'nullable|string|max:255',
                                location.'state'          => 'nullable|string|max:255',
                                location.'country'        => 'nullable|string|max:255',
                                location.'postal_code'    => 'nullable|string|max:255', 
                            */}

                            {formModel.is_onsite && (
                                <div className="md:w-4/5">
                                    <p>On-site location address</p>

                                    <div className="md:flex gap-6">

                                        <FormInputComponent
                                            fieldName="location.address_line_1"
                                            value={formModel.location?.address_line_1}
                                            label="Street Address"
                                            // placeholder="1234 5th Street"
                                            type="antd-input"
                                            required
                                            className="flex-1"
                                        >
                                            <Input />
                                        </FormInputComponent>

                                        <FormInputComponent
                                            fieldName="location.address_line_2"
                                            value={formModel.location?.address_line_2}
                                            label="Suite, etc."
                                            // placeholder="STE. 42"
                                            type="antd-input"
                                            required={false}
                                            className="flex-1"
                                        >
                                            <Input />
                                        </FormInputComponent>
                                    </div>

                                    <div className="md:flex gap-6">
                                        <FormInputComponent
                                            fieldName="location.city"
                                            value={formModel.location?.city}
                                            label="City"
                                            // placeholder="STE. 42"
                                            type="antd-input"
                                            required
                                            className="flex-1"
                                        >
                                            <Input />
                                        </FormInputComponent>

                                        <FormInputComponent
                                            fieldName="location.state"
                                            value={formModel.location?.state}
                                            label="State"
                                            // placeholder="STE. 42"
                                            type="antd-input"
                                            required
                                            className="flex-1"
                                        >
                                            <Select options={statesOptions} />

                                        </FormInputComponent>

                                        <FormInputComponent
                                            fieldName="location.postal_code"
                                            value={formModel.location?.postal_code}
                                            label="Zipcode"
                                            // placeholder="STE. 42"
                                            type="antd-input"
                                            required
                                            className="flex-1"
                                        >
                                            <Input />
                                        </FormInputComponent>


                                        <FormInputComponent
                                            fieldName="location.country"
                                            value={formModel.location?.country}
                                            label="Country"
                                            // placeholder="STE. 42"
                                            type="antd-input"
                                            required
                                            className="flex-1"
                                        >
                                            <Select options={[placeHolderOption, ...COUNTRIES]} />

                                        </FormInputComponent>
                                    </div>

                                </div>
                            )}
                            <FormInputComponent
                                type="antd-input"
                                value={formModel.work_timezone || false}
                                fieldName="work_timezone"
                                label="What is the work timezone for the candidate?"
                                placeholder="Select an option..."
                                required={true}>

                                <Select options={timezoneOptions} />

                            </FormInputComponent>

                            {shouldShowTaxQuestions && TB.map(formModel.client_tax_questions || [], (question, questionIndex) => (
                                <div key={`tax-questions-${question.title}`} className="flex mb-2 flex-row">

                                    <div className="form-group flex-grow">
                                        <label className="col-form-label flex flex-col items-start gap-2">
                                            <span>
                                                {question.title} *
                                            </span>
                                            {question.help_text?.length > 0 && (
                                                <span className="text-xs italic mb-2">
                                                    {question.help_text}
                                                </span>
                                            )}
                                        </label>

                                        <div className="field-section flex-row">
                                            <div className="field basis-full lg:basis-2/3">
                                                <FormInputComponent
                                                    type="antd-input"
                                                    label={false}
                                                    required={true}
                                                    invalidStyles={{ top: '100%' }}
                                                    fieldName={`client_tax_questions[${questionIndex}].answer`}
                                                    value={question.answer}>

                                                    <Radio.Group value={question.answer}>
                                                        <Radio value="yes">
                                                            Yes
                                                        </Radio>
                                                        <Radio value="no">
                                                            No
                                                        </Radio>
                                                    </Radio.Group>

                                                </FormInputComponent>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>


                        <div className="flex mt-5 flex-row justify-end gap-3">

                            <button
                                type="button" disabled={isDisabled}
                                className="btn btn-outline-dark" onClick={onClose}>
                                Cancel
                            </button>

                            <button
                                type="submit"
                                disabled={isDisabled}
                                className="btn btn-primary">
                                Submit Request
                            </button>
                        </div>
                    </Form>
                </React.Fragment>

            </div>
        </SpinLoader>
    );
}

export default PositionCandidateGreenlightModal;